/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Current patient draft demographics sent only in the request body
 * @export
 * @interface KinnserPatientSearchRequest
 */
export interface KinnserPatientSearchRequest {
    /**
     * 
     */
    first_name: string;
    /**
     * 
     */
    last_name: string;
    /**
     * Birth date in MM/DD/YYYY format
     */
    date_of_birth: string;
    /**
     * 
     */
    sex?: string;
    /**
     * 
     */
    phone?: string;
}

/**
 * Check if a given object implements the KinnserPatientSearchRequest interface.
 */
export function instanceOfKinnserPatientSearchRequest(value: object): value is KinnserPatientSearchRequest {
    if (!('first_name' in value) || value['first_name'] === undefined) return false;
    if (!('last_name' in value) || value['last_name'] === undefined) return false;
    if (!('date_of_birth' in value) || value['date_of_birth'] === undefined) return false;
    return true;
}

export function KinnserPatientSearchRequestFromJSON(json: any): KinnserPatientSearchRequest {
    return KinnserPatientSearchRequestFromJSONTyped(json, false);
}

export function KinnserPatientSearchRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): KinnserPatientSearchRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'first_name': json['first_name'],
        'last_name': json['last_name'],
        'date_of_birth': json['date_of_birth'],
        'sex': json['sex'] == null ? undefined : json['sex'],
        'phone': json['phone'] == null ? undefined : json['phone'],
    };
}

export function KinnserPatientSearchRequestToJSON(json: any): KinnserPatientSearchRequest {
    return KinnserPatientSearchRequestToJSONTyped(json, false);
}

export function KinnserPatientSearchRequestToJSONTyped(value?: KinnserPatientSearchRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'date_of_birth': value['date_of_birth'],
        'sex': value['sex'],
        'phone': value['phone'],
    };
}

